import React, {Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import reportWebVitals from './reportWebVitals'

function showBootError(err) {
    const root = document.getElementById('root');
    const message = (err && (err.stack || err.message)) ? (err.stack || err.message) : String(err);
    console.error('FRA Wizard boot error:', err);
    if (root) {
        root.innerHTML = `<div style="padding:24px;font-family:sans-serif;color:#b00020;white-space:pre-wrap"><h1>App failed to start</h1><pre>${message.replace(/[<>&]/g, c => ({'<':'&lt;','>':'&gt;','&':'&amp;'}[c]))}</pre></div>`;
    }
}

window.addEventListener('error', (e) => {
    if (!document.getElementById('root')?.childElementCount) {
        showBootError(e.error || e.message);
    }
});

window.addEventListener('unhandledrejection', (e) => {
    if (!document.getElementById('root')?.childElementCount) {
        showBootError(e.reason);
    }
});

(async () => {
    try {
        await import('@/assets/scss/app.scss');
        await import('./i18n');
        const { default: App } = await import('./App');
        const { default: LoadingCover } = await import('@/components/LoadingCover');

        var pushState = window.history.pushState;
        window.history.pushState = function () {
            var event = new Event('pushState');
            event.state = arguments[0];
            event.title = arguments[1];
            event.url = arguments[2];
            var result = pushState.apply(this, arguments);
            window.dispatchEvent(event);
            return result;
        };

        const root = createRoot(document.getElementById('root'));
        root.render(
            <Suspense fallback={<LoadingCover/>}>
                <App/>
            </Suspense>
        );
    } catch (err) {
        showBootError(err);
    }
})();

reportWebVitals();
